/**
 * Colour roles for the Comic & Manga world figures (night city). Storybook (A) values are hand-picked
 * (warm, slightly muted, ART-BIBLE §5.3: neon pink / mint, moon cream); Sticker (B) and Pastel (C) are
 * derived by `rolePalette`. Every role is prefixed `anime` so it never clashes with another world.
 */
import { rolePalette } from '../../art/palette';

export const ANIME_PALETTE = rolePalette({
  // faces + eyes (shared by every manga character)
  animeSkin: '#F7D7BF',
  animeIris: '#5C8FD6',
  animeIrisDark: '#34548F',
  animeIrisLight: '#A9D3F2',
  animeMouth: '#C9566A',
  // hair
  animeHairPink: '#F09DB6',
  animeHairPinkDark: '#C96B8A',
  animeHairBlue: '#5F79C4',
  animeHairBlueDark: '#3F5698',
  animeHairLilac: '#B49BE0',
  animeHairLilacDark: '#8466BE',
  // outfits
  animeSailor: '#6E78C8',
  animeBow: '#F07A93',
  animeShirt: '#F6CD5A',
  animeShorts: '#4FA9A6',
  animeShoe: '#E1675A',
  // mochi cat mascot
  animeMochi: '#FFF6EA',
  animeMochiPatch: '#F2B57E',
  // star wand
  animeStar: '#F8D35E',
  animeStarDeep: '#EDB23F',
  animeWand: '#F4A6C4',
  animeRibbon: '#7FD3D8',
  animeGem: '#E8678F',
  // ninja
  animeNinja: '#5A69B9',
  animeNinjaDark: '#3E4889',
  animeBand: '#E8604F',
  animeLeafPink: '#F6B3C8',
  // baby dragon
  animeDragon: '#7DC6A2',
  animeDragonDark: '#4E9A80',
  animeDragonBelly: '#FBE6B4',
  animeDragonWing: '#F4A98C',
  animeHorn: '#F6E3BE',
  // moon + ghost doodles
  animeMoon: '#FBE29B',
  animeMoonDeep: '#E9C26A',
  animeNightcap: '#7E8EDB',
  animeGhost: '#F3F0FF',
  // Lantern Bridge cast (v2): a second skin tone, hair, outfits and props
  animeSkinDeep: '#C98D66',
  animeHairDark: '#5B4567',
  animeHairDarkDeep: '#3F2F4A',
  animeHairBrown: '#9A6448',
  animeLantern: '#EE7A5A',
  animeLanternDeep: '#C9573F',
  animeLanternGold: '#F6B34F',
  animeGlow: '#FFE7A6',
  animeCloud: '#F5F7FF',
  animeCloudShade: '#C9D0EE',
  animeRain: '#9CCBEA',
  animeJelly: '#C8B5F0',
  animeJellyDeep: '#9A81D6',
  animeJellyFrill: '#F2B6D3',
  animeBoard: '#5ACBC4',
  animeBoardDeep: '#2F9C9B',
  animeFrog: '#8FC96E',
  animeFrogDark: '#5E9A4C',
  animeBear: '#B98762',
  animeBearDark: '#8C5F43',
  animeCape: '#4F5DB2',
  animeCapeLining: '#F3C2D4',
  animePaper: '#FFF3DE',
  animeMooncake: '#D9A25E',
  animeMooncakeDeep: '#B07A3E',
  animeTear: '#A7DDF4',
  animeSnowflake: '#CDEBFA',
  animeBlossom: '#F7C3D2',
  animeBranch: '#8E6249',
  animeSteam: '#F1EEF8',
  animeCocoa: '#A8704F',
  animeSatchel: '#E2A564',
  animeNightTop: '#2D2E62',
  animeNightMid: '#4B4A8C',
  animeNightLow: '#8E78B2',
  animeCityGlow: '#E9B3A2',
  animeRoof: '#6F6AA8',
  animeRoofNear: '#585490',
  animeCobble: '#8C86A8',
  animeCobbleNear: '#726C92',
  animeRiver: '#3F5A8E',
  animeRiverNear: '#33497A',
  animeWoodNight: '#9C6E57',
  animeWoodNightNear: '#7E5646',
  animeStoneNight: '#A9A3C2',
  animeNeon: '#FF8FB8',
  animeNeonMint: '#7FE3D2',
});
